import store from 'store';
import { validate } from 're-enrollment-checklist/cobra/cover-letter/cobraOePacket.middleware';

export function validateCobraPlans(): any {
  return (next: any) => async (action: any) => {
    return validate(store)(next)(action);
  };
}
